import { login, logout } from '@/api/system/login'
import { getMe } from '@/api/system/user'
import { getToken, setToken, removeToken } from '@/utils/auth'

const user = {
  state: {
    token: getToken(),
    user_id: 0,
    name: '',
    avatar: '',
    roles: [],
    user_info: {}
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_USER_ID: (state, user_id) => {
      state.user_id = user_id
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_USER_INFO: (state, data) => {
      state.user_info = data
    }
  },

  actions: {
    // 登录
    Login({ commit }, loginParam) {
      loginParam.account.trim()
      return new Promise((resolve, reject) => {
        login(loginParam).then(response => {
          const data = response.data
          // const payload = jwt.decode(data.token, TOKEN_SECRET, false, 'RS256')
          console.debug('login',data)
          setToken(data.token)
          commit('SET_TOKEN', data.token)
          // commit('SET_USER_ID', payload.sub)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 获取用户信息
    GetUser({ commit }) {
      return new Promise((resolve, reject) => {
        getMe().then(response => {
          const data = response.data
          commit('SET_NAME', data.user_name)
          commit('SET_AVATAR', data.avatar)
          commit('SET_USER_ID', data.user_id)
          commit('SET_USER_INFO', data)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 登出
    LogOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        logout(state.token).then(() => {
          commit('SET_TOKEN', '')
          commit('SET_USER_ID', 0)
          commit('SET_ROLES', [])
          removeToken()
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 前端 登出
    FedLogOut({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        removeToken()
        resolve()
      })
    }
  }
}

export default user
